import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { SearchTeamMembersParams } from './useSearchTeamMembers';

/**
 * Query keys for team API calls
 * All keys include servicesProviderId to ensure proper cache isolation between accounts
 *
 * To invalidate ALL team queries, use: queries.team._def
 */
export const team = createQueryKeys('team', {
	list: (servicesProviderId: string, params?: SearchTeamMembersParams) => ({
		queryKey: [servicesProviderId, params],
	}),
});
